module.exports = __webpack_public_path__ + "static/media/Pin-Regular.762ce8aa.svg";